module.exports = __webpack_public_path__ + "static/media/events_05.7d06e5aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_05.jpg
// module id = 5923
// module chunks = 0